import React from 'react'
import styled from '@emotion/styled'

import vw from 'styles/utils';

function Advertisement() {
  return (
    <Root as="a" href="https://ieknet.iek.org.tw/IEKTopics/2024/" target="_blank">
      {/* <p>廣告版位</p> */}
    </Root>
  )
}

const Root = styled.section`
  width: 100%;
  background-image: url(${require('assets/images/home/advertisment.jpg')});
  background-size: cover;
  background-position: center bottom;
  display: flex;
  justify-content: center;
  align-items: center;

  ${vw('height', 65, 165, 200)}
  ${vw('margin-bottom', 20, 30)}

  > p {
    color: #FFFFFF;
  }
`;

export default Advertisement
